var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"webchat-container",class:{ minimized: _vm.isMinimized }},[_c('div',{staticClass:"webchat-header",on:{"click":_vm.toggleMinimize}},[_c('span',[_vm._v("Chat")]),(_vm.isMinimized)?_c('i',[_vm._v("+")]):_c('i',[_vm._v("_")])]),_c('div',{staticClass:"webchat-content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }